import React, { PropsWithChildren, ReactNode, createContext, useState } from 'react';

type TableUtilsContextType = {
  expandedWorkflows: number[];
  setExpandedValue: (id: number, value?: boolean) => void;
  isExpanded: (id: number) => boolean;
  setPage: (page: number) => void;
  scrollToTop: () => void;
};

export const TableUtilsContext = createContext<TableUtilsContextType | undefined>(undefined);

export const TableUtilsProvider: React.FC<{ tableObject: TableUtilsContextType; children: ReactNode }> = ({
  children,
  tableObject,
}) => {
  return <TableUtilsContext.Provider value={tableObject}>{children}</TableUtilsContext.Provider>;
};

export const useWorkflowTableUtilsContext = () => {
  const context = React.useContext(TableUtilsContext);
  if (context === undefined) {
    throw new Error('useWorkfloTableContext must be used within a TableProvider');
  }

  return context;
};
